<template lang="pug">
  v-select(
    dense
    outlined
    hide-details
    :value='value'
    :items='itemsTrans'
    item-text='name'
    item-value='value'
    :label="$t('label.select-status')"
    @input="$emit('input',$event)"
    @click="$emit('click')"
  )

</template>
<script>
export default {
  props:{
    value:{
      type:String,
      default:null
    }
  },
  data: () => ({
    items:[
      {
        name:"all",
        value:null,
      },
      {
        name:"WAITING",
        value: [1,2,7,8],
      },
      {
        name:"DONE",
        value: [3,4]
      },
      {
        name:"CANCELED",
        value: [5,6],
      },
    ] 
  }),
  computed: {
    itemsTrans () {
      return this.items.map(x=>{ 
        x.name = this.$t(x.name) 
        return x
      })
    }
  }
}
</script>